/**

@ngdoc directive
@name costCode

@description
Cost Code Widget

@usage
    <cost-code
        label="Cost codes"   // label for the whole field
        ng-required="true"   // required
        ng-readonly="false"  // read only field
        ng-disabled="false"  // disabled field
        init-id="758,780"    // (optional) init cost codes values (will be loaded on widget load)
        init-percent="25,75"> // (optional) init percent value (warning - it needs to be corresponding to the id's)
    </cost-code>

*/

(function() {
  'use strict';

var costCodeDirective = function ($http, $filter, $timeout, $sce, $document, $templateCache, formFieldFactory) {

    var isObjectEmpty = function(obj){
        return Object.keys(obj).length ? false : true;
    }

    return {
        restrict: "EA",
        scope: {
            label:"@",
            ngRequired: "=",
            ngReadonly: "=",
            ngDisabled: "=",
            prefixName: "@",
            myModel: "=?"
        },
        priority:200, // TODO: needed?
        replace: true,
        transclude: false,
        template: $templateCache.get('formWidget/costCode.html'),
        controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs){


            /*var costCodes = new CostCodes();
            costCodes.add(19.99);
            console.log('here');
            console.log( costCodes.getTotalPercent() );*/

            // init values
            var _this = this;
            $scope.costCodes = {};
            // var costCodes = new CostCodes();

            $scope.newCostCode = null;
            $scope.totalPercent = "";
            $scope.widget = { // widget state
                emptyCostCode : true,
                tableTouched  : false,
                warningExists : false
            }
            $scope.addPopover = {
                open  : false,
                title : '',
                html  : ''
            };


            (function initialize(){

                $scope.newCostCodeModel = {
                    addCostPercent:100, // 100% by default as requested
                };

                if( angular.isDefined($attrs.init) && $attrs.init!='' ){
                    $scope.costCodes = angular.fromJson($attrs.init);
                    // costCodes.costCodes = angular.fromJson($attrs.init);
                }
                if( !isObjectEmpty($scope.costCodes) ){ // although $attrs.init it still might be empty
                    $scope.newCostCodeModel = {};

                    var initIds = new Array();
                    angular.forEach($scope.costCodes, function(cc){
                        initIds.push(cc.costCodeId);
                    });
                    /*console.log('init ids');
                    console.log(initIds);
                    console.log(costCodes.getAllIds());*/
                    // load cost codes on start
                    $http.get( WEBAPP_PATH + '/costCode/findCostCodeMap?costCodeId='+initIds.join(",")).then(
                        function(response){
                            angular.forEach(response.data, function(resp){
                                $scope.costCodes[resp.id].costCode = resp;
                                // costCodes.add(resp);
                            });
                            $scope.updateTotalCost();
                            $scope.widget.emptyCostCode = isObjectEmpty( $scope.costCodes );
                        }, function(){ // on fail
                            console.warn('Warning: Cost Code widget initialization failed. No initial cost codes loaded.');
                        }
                    );
                }
            })(); // () - executes on declaration


            this.getCostCode = function(val) {
                return $http.get( WEBAPP_PATH + '/costCode/findCostCodeMap?costCodeId='+val).then(
                    function(response){
                        $scope.widget.warningExists = (angular.isDefined( $scope.costCodes[response.data[0].id] )) ? true : false;
                        $scope.newCostCode = {
                            "costCodeId" : response.data[0].id,
                            "costCode"   : response.data[0]
                        };
                        // $scope.propertiesCostCode = response.data[0]; // for showing properties table
                        console.log('getCostCode');
                        console.log($scope.newCostCode);
                        $scope.addPopover = {
                            open: true,
                            title: $scope.newCostCode.costCode.costCode,
                            html: $sce.trustAsHtml( $scope.createPropertiesHtml($scope.newCostCode.costCode.costCodeLevels) )
                        };
                    }
                );
            }
            // obj[Object.keys(obj)[0]]

            $scope.addCostCode = function(){

                if($scope.ngDisabled){
                    return false;
                }

                $scope.invalidAddErrorMsg = true;
                // if valid
                if( angular.isNumber($scope.newCostCodeModel.addCostPercent) && $scope.newCostCodeModel.addCostPercent > 0 && $scope.newCostCodeModel.addCostPercent <= 100 ){
                    // and new cost code selected from autocomplete
                    if( angular.isDefined($scope.newCostCode) && angular.isObject($scope.newCostCode) ){

                        $scope.invalidAddErrorMsg = false;

                        $scope.newCostCode.costCodePercent = $scope.newCostCodeModel.addCostPercent; // add percent value to the object
                        $scope.costCodes[$scope.newCostCode.costCodeId] = $scope.newCostCode;
                        if($scope.myModel && $scope.myModel[$scope.prefixName]  &&
                           $scope.myModel[$scope.prefixName][$scope.newCostCode.costCodeId]) {
                            $scope.myModel[$scope.prefixName][$scope.newCostCode.costCodeId].costCodeIdForLookup = $scope.newCostCode.costCodeId;
                            $scope.myModel[$scope.prefixName][$scope.newCostCode.costCode].costCodeValue = $scope.newCostCode.costCode.costCode;
                        }
                        $scope.updateTotalCost();
                        $scope.widget.emptyCostCode = isObjectEmpty( $scope.costCodes );
                        if($scope.myModel.MetOrgId == $scope.myModel.bookingOrgId) {
                        $scope.myModel.clientCode2 =  null;
                        $scope.myModel.clientCode3 =  null;
                        }
                        resetAutocomplete();
                        $scope.resetAddPopover();
                    }
                }
                return false;
            }
            $scope.removeCostCode = function(id, event){
                if($scope.myModel && $scope.myModel[$scope.prefixName]) {
                    delete $scope.myModel[$scope.prefixName][$scope.costCodes[id].costCodeId];
                    delete $scope.myModel[$scope.prefixName][$scope.costCodes[id].costCode];
                }
                delete $scope.costCodes[id];
                $scope.updateTotalCost();
                $scope.widget.emptyCostCode = isObjectEmpty( $scope.costCodes );
                $scope.widget.tableTouched = true;

                // if no cost codes % should default to 100
                if(Object.keys($scope.costCodes).length === 0){
                    $scope.newCostCodeModel.addCostPercent = 100;
                }
                event.preventDefault();
                $element.focus(); // a11y
            }

            $scope.updateTotalCost = function(){
                $scope.totalPercent = 0;
                angular.forEach($scope.costCodes, function(costCode, key) {
                    $scope.totalPercent += isFinite(costCode.costCodePercent) ? costCode.costCodePercent : 0;
                });
                // empty string if 0 for validation (validation based on totalPercent value)
                $scope.totalPercent = $scope.totalPercent == 0 ? "" : $scope.totalPercent;
                formFieldFactory.triggerDependantFieldValidation($scope.form['costsTotalPercent']); // set field to touched
                // TODO: triggerDependantFieldValidation should be called only once
            }

            // validation
            $scope.invalidFormCondition = function(){
                return $scope.totalPercent!=100 && ($scope.ngRequired || (!$scope.ngRequired && $scope.totalPercent>0));
            }

            // reset add cost code form and properties view
            var resetAutocomplete = function() {
                $scope.newCostCodeModel.costCodeTypehead = "";
                $scope.newCostCodeModel.addCostPercent = "";
                $scope.newCostCode = null;
                // $scope.propertiesCostCode = null; // for showing properties table
                $scope.widget.warningExists = false;
            }

            $scope.resetAddPopover = function(){
                $scope.addPopover = {
                    open: false,
                    title:'',
                    html:'',
                };
            }
        }],
        require: ['^form','costCode'], // parent form binding
        link: function(scope, element, attrs, ctrls) {

            scope.form = ctrls[0];
            var ctrl = ctrls[1];

            $timeout(function(){
                scope.widgetInvalid = scope.invalidFormCondition();
            });

            // once you hit enter on the percentage field
            scope.submitCode = function($event){
                scope.addCostCode();
                $event.preventDefault();
            }

            // performance reason
            scope.$watch(
                function(scope){
                    return scope.invalidFormCondition();
                },
                function( newVal, oldVal ){
                    if(newVal != oldVal){
                        scope.widgetInvalid = newVal;
                    }
                }
            );

            // watch autocomplete for change and get the new cost code if selected
            scope.$watch(
                function(scope){
                    return scope.newCostCodeModel.costCodeTypehead;
                },
                function( newVal, oldVal ) {
                    // once selected the model becomes the object
                    if(newVal != oldVal) {
                        if( angular.isObject(newVal) ) {
                            if( angular.isNumber(newVal.key) ) {
                                ctrl.getCostCode(newVal.key);
                            } else {
                                scope.resetAddPopover();
                                scope.newCostCode = null;
                                console.warn('Warning: Unable to get the cost code.');
                            }
                        } else {
                            scope.resetAddPopover();
                            scope.newCostCode = null;
                        }
                    }
                }
            );


            /** Popovers **/
            var createPopoversHtml = function(){
                var templates = {};
                angular.forEach(scope.costCodes, function(cc, id, objCc){
                    templates[id] = $sce.trustAsHtml( scope.createPropertiesHtml(objCc[id].costCode.costCodeLevels) );
                });
                return templates;
            }

            scope.createPropertiesHtml = function(costCodeProperties){
                var tableTemplate = '<table class="table table-sm"><tbody>';

                angular.forEach(costCodeProperties, function(val, prop){
                    tableTemplate += [
                        '<tr>',
                            '<th scope="row">'+prop+'</th>',
                            '<td><strong>'+(val===null ? '' : val)+'</strong></td>',
                        '</tr>'].join("");
                });
                tableTemplate += '</tbody></table>';
                return tableTemplate;
            }

            scope.$watch(
                function(scope){
                    return scope.costCodes;
                },
                function(newVal, oldVal){
                    if(newVal!=oldVal){
                        scope.popoversHtml = createPopoversHtml();
                    }
                },
                true
            );


            scope.popoverOpen = Object(); // this is required, otherwise popoverOpen get initialized only in popover scope
            var closePopoverClick = function(event){
                var target = angular.element(event.target);
                if(!target.closest('.popoverOpen').length && target.attr('uib-popover-html')==undefined ){
                    // if I didn't click inside popover nor popover trigger link
                    scope.$apply(function(){
                        scope.popoverOpen = {}; // in theory it could/should do forEach
                        unbindPopoverEvents(); // unbind as not longer needed
                    });
                }
                // TODO: $rootScope.emit('close-the-other-popovers');
            }
            var closePopoverEsc = function(e){
                if(e.keyCode == 27) { // on ESC
                    scope.$apply(function(){
                        scope.popoverOpen = {}; // in theory it could/should do forEach
                        unbindPopoverEvents();
                    });
                }
            }
            scope.bindPopoverCloseEvents = function(){
                // close popover on document click
                $document.on('click', closePopoverClick);
                $document.on('keyup', closePopoverEsc);
            }
            var unbindPopoverEvents = function(){
                $document.off('click', closePopoverClick);
                $document.off('keyup', closePopoverEsc);
            }

            /* on costCode destroy */
            scope.$on('$destroy', function(){
                unbindPopoverEvents();
            });
        }
    };
}

costCodeDirective.$inject = ['$http', '$filter', '$timeout', '$sce', '$document', '$templateCache', 'formFieldFactory'];
angular.module('app').directive('costCode', costCodeDirective);

}());
